import { Box, Paper, TablePagination } from "@mui/material";
import { useEffect, useState } from 'react';
import { styles } from "./cards_old";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CustomAxios from '../utils/CustomAxios';
import { TranslateText } from "../utils/googletranslator";

const CommisionHistoryComponent = () => {
    const [commisionData, setCommisionData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        const payload = {
            order_id: null,
            page: page + 1,
            page_size: rowsPerPage,
        };

        CustomAxios.post('share-commision/', payload)
            .then((res) => {
                if (Array.isArray(res.data)) {
                    setCommisionData(res.data);
                    setTotalCount(res.data.length);
                    return;
                }

                if (res.data) {
                    setCommisionData(res.data.results || []);
                    setTotalCount(res.data.count || 0);
                }
            })
            .catch((err) => {
                console.error(err);
                setCommisionData([]);
                setTotalCount(0);
            });
    }, [page, rowsPerPage]);

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "32px" }}>
            <Paper sx={{ width: "100%", bgcolor: "#fff", padding: "32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <TranslateText sx={styles.header}>Commision History</TranslateText>
            </Paper>
            <Box>
                <TableContainer component={Paper} sx={{ bgcolor: "#fff" }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead >
                            <TableRow>
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }}>Refered Username</TableCell>
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }}>Commision Received</TableCell>
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">TDS Amount</TableCell>
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">Order ID</TableCell>
                                {/* <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">Purchased Order ID</TableCell> */}
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">Purchased Order Username</TableCell>
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">Purchased Milestone</TableCell>
                                {/* <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">Purchased Milestone</TableCell> */}
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">Type</TableCell>
                                <TableCell sx={{ fontWeight: "600", textAlign: "center" }} align="right">Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {commisionData.length >= 1 ?
                                commisionData.map((product, prod_id) => {
                                    return (
                                        <TableRow
                                            key={product.id || prod_id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell sx={{ textAlign: "center" }}>{product.referred_user ? product.referred_user.first_name + " " + product.referred_user.last_name : 'No User Found'}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>{product.commission_received}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>{product.tds_amount}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>{product.orders?.id}</TableCell>
                                            {/* <TableCell sx={{ textAlign:"center" }}>{product.orders?.razorpay_order_id || product.orders?.cash_pickup_id || product.orders?.order_id} </TableCell> */}
                                            <TableCell sx={{ textAlign: "center" }}>{product.orders?.user ? product.orders?.user.first_name + " " + product.orders?.user.last_name : "No User Found"}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>{product.package?.name ? product.package?.name : product.type == 'incentive' ? 'Incentive' : "No Package History"}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>{product.type == "plan" ? "Fasnus Bonus" : "Generation Bonus"}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>{product.status}</TableCell>
                                            {/* <TableCell sx={{ textAlign: "center" }}>{product.package.name}</TableCell> */}

                                            {/* <TableCell sx={{ textAlign:"center" }}>{product.status}</TableCell> */}
                                        </TableRow>
                                    );
                                })
                                : (
                                    <TableRow>
                                        <TableCell colSpan={8} sx={{ textAlign: "center", py: 4 }}>
                                            No commission history found
                                        </TableCell>
                                    </TableRow>
                                )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        count={totalCount}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50]}
                    />
                </TableContainer>
            </Box>
        </Box>
    );
};

export default CommisionHistoryComponent;
